import { reactQueryClient } from "@redotech/redo-web/rpc-query/react-query-config";
import { lazy, memo, Suspense, useEffect, useState } from "react";

const tanstackQueryDevtoolsAvailable =
  process.env.NODE_ENV === "development" ||
  window.location.hostname.endsWith(".sandbox.redo.run");

const ReactQueryDevtools = lazy(() => {
  if (process.env.NODE_ENV === "development") {
    // redont-allow-dynamic-import: lazy-load development-only tooling
    return import("@tanstack/react-query-devtools").then((mod) => ({
      default: mod.ReactQueryDevtools,
    }));
  }
  if (tanstackQueryDevtoolsAvailable) {
    // redont-allow-dynamic-import: lazy-load tooling only in sandbox environments
    return import("@tanstack/react-query-devtools/production").then((mod) => ({
      default: mod.ReactQueryDevtools,
    }));
  }
  return Promise.resolve({ default: () => null });
});

export const TanStackQueryDevtools = memo(function TanStackQueryDevtools() {
  const [shouldShowDevtools, setShouldShowDevtools] = useState(
    () =>
      tanstackQueryDevtoolsAvailable &&
      new URLSearchParams(window.location.search).get("tanstack") === "query",
  );

  useEffect(() => {
    if (!tanstackQueryDevtoolsAvailable) {
      return;
    }

    Reflect.set(window, "toggleTanStackQueryDevtools", () => {
      setShouldShowDevtools((devtoolsVisible) => !devtoolsVisible);
    });

    return () => {
      Reflect.deleteProperty(window, "toggleTanStackQueryDevtools");
    };
  }, []);

  if (!shouldShowDevtools) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ReactQueryDevtools
        buttonPosition="bottom-right"
        client={reactQueryClient}
        initialIsOpen={false}
        position="bottom"
      />
    </Suspense>
  );
});
